<article class="main-info" role="contentinfo">
    <div class="row">
        <div class="col-12 col-md-5 img-column">
            <img src="./assets/img/Ilustracion_moto_nueva.png" alt="">
        </div>
        <div class="col-12 col-md-7 px-4">
            <form class="new-vehicle-form">
                <fieldset class="group mt-3">
                    <label class="new-vehicle-label" for="vehicle-value" [class.text-danger]="labelError()">*Valor total
                        en
                        pesos
                        (incluye IVA)</label>
                    <input type="text" id="vehicle-value" name="vehicleValue" class="form-control mt-1
                             estiloPrincipal" placeholder="Ej: $30.000.000" [ngModel]="vehicleValue()"
                        (ngModelChange)="handleValueChange($event)" 
                        (input)="validateNumber($event)"
                         required appCurrencyFormatter />

                         @if(showError()) {
                            <small class="error">{{errorMessage()}}</small>
                        }

                    <small class="validate">Verificaremos que el valor coincida con la factura.</small>


                </fieldset>

                <app-file-upload  [maxFiles]="1" (disableButton)="handleDisabledButton($event)"
                    (filesChanged)="handleFilesUploaded($event)"></app-file-upload>

                <app-button [text]="'Continuar'" [type]="'primary'" [size]="'small'" [witch]="'fullwidth'"
                    [disabled]="!isFormValid()|| showError() || disableSubmitButton()" (clicked)="onSubmit()   "></app-button>
            </form>
        </div>
    </div>
</article>